
























































import {Component, Prop, Vue, Watch} from "vue-property-decorator";

// @ts-ignore
import VuetifyAudio from 'vuetify-audio';

import Feedback from "@/components/Feedback.vue";
import axios from "axios";
import PlantEditButton from "@/components/PlantEditButton.vue";
import QrCodes from "@/components/QrCodes.vue";

const API_URL = process.env.VUE_APP_API_PATH + '/';
@Component({
    components: {QrCodes, PlantEditButton, Feedback, VuetifyAudio}
})
export default class Plant extends Vue {


    private plant: any = {};

    private showAudio = false;

    mounted() {
        this.log()
        this.load()
    }

    log() {
        const id = this.$route.params.id;
        const lang = this.$route.params.lang;

        axios.get(API_URL + "api/public/log_plant?plantId=" + id + "&lang=" + lang)
    }

    get plantDescription() {
        // @ts-ignore
        return this.$sanitize(this.plant.description.replace(/\n/g, "<br\>"))
    }

    download() {
        const id = this.$route.params.id;
        const lang = this.$route.params.lang;

        window.location.href = API_URL + "api/public/plants/pdf/" + id + "/" + lang;
    }

    @Watch("$route.params.lang", {deep: true})
    load() {
        this.showAudio = false
        const id = this.$route.params.id;
        const lang = this.$route.params.lang;

        axios.get(API_URL + "api/public/plants/" + id + "/" + lang)
            .then(res => {
                this.plant = {
                    id: res.data.id,
                    description: res.data.description,
                    name: res.data.name,
                    latin: res.data.latin,
                    author: res.data.author,
                    img: API_URL + "api/public/plants/image/" + id,
                    audio: API_URL + "api/public/plants/audio/" + id + "/" + lang
                }
            })
            .then(() => {
                axios.get(this.plant.audio, {headers: {"Range": "bytes=0-1"}}).then(res => {
                    this.showAudio = true;
                }).catch(() => {})
            })
    }

    clicked() {

    }
}
